export const HSE_DIGEST_TIMEZONE = "Europe/Oslo";

export const HSE_DIGEST_WEEKDAY_ORDER = [1, 2, 3, 4, 5, 6, 0];

export const HSE_DIGEST_WEEKDAY_KEYS = {
  0: "hse.digest.weekday.sunday",
  1: "hse.digest.weekday.monday",
  2: "hse.digest.weekday.tuesday",
  3: "hse.digest.weekday.wednesday",
  4: "hse.digest.weekday.thursday",
  5: "hse.digest.weekday.friday",
  6: "hse.digest.weekday.saturday",
};

const WEEKDAY_NAMES = {
  sunday: 0,
  sun: 0,
  monday: 1,
  mon: 1,
  tuesday: 2,
  tue: 2,
  wednesday: 3,
  wed: 3,
  thursday: 4,
  thu: 4,
  friday: 5,
  fri: 5,
  saturday: 6,
  sat: 6,
};

const emptySettings = {
  enabled: false,
  weekday: 1,
  hour: 8,
  timezone: HSE_DIGEST_TIMEZONE,
  last_digest_on: null,
};

/** Date.wday: 0 = Sunday … 6 = Saturday. ISO Sunday (7) maps to 0. */
export function normalizeHseDigestWeekday(value, fallback = 1) {
  if (typeof value === "string") {
    const key = value.trim().toLowerCase();
    if (Object.prototype.hasOwnProperty.call(WEEKDAY_NAMES, key)) {
      return WEEKDAY_NAMES[key];
    }
    const parsed = Number.parseInt(key, 10);
    return normalizeHseDigestWeekday(parsed, fallback);
  }

  const n = Number(value);
  if (!Number.isInteger(n)) return fallback;
  if (n === 7) return 0;
  if (n >= 0 && n <= 6) return n;
  return fallback;
}

export function normalizeHseDigestHour(value, fallback = 8) {
  const n = Number(value);
  if (!Number.isInteger(n)) return fallback;
  if (n < 0 || n > 23) return fallback;
  return n;
}

export function normalizeHseDigestSettings(data = {}) {
  return {
    enabled: data.enabled === true,
    weekday: normalizeHseDigestWeekday(data.weekday, 1),
    hour: normalizeHseDigestHour(data.hour, 8),
    timezone: data.timezone || HSE_DIGEST_TIMEZONE,
    last_digest_on: data.last_digest_on || null,
  };
}

export function snapshotHseDigestSettings(data) {
  return JSON.stringify({
    enabled: data.enabled === true,
    weekday: normalizeHseDigestWeekday(data.weekday, 1),
    hour: normalizeHseDigestHour(data.hour, 8),
  });
}

export function emptyHseDigestSettings() {
  return { ...emptySettings };
}
